import { HttpRequest } from '@aws-sdk/protocol-http';
import { logError, logInfo, logWarn } from './logger';
import { useAwsStore } from '@/stores/aws';

// // Define at top level
const pollUrl = import.meta.env.VITE_APP_POLL_URL;
const localizedUrl = import.meta.env.VITE_APP_LOCALIZED_URL;

// // Backend API helper functions

// // Backend API functions

const getSigner = () => {
  const storeAws = useAwsStore();
  return storeAws.getSigner();
};

const signedFetch = async (request) => {
  const signer = getSigner();
  if (!signer) {
    throw new Error('AWS signer not initialized. Call initializeAwsCredentials() first.');
  }
  // The HttpRequest object from @aws-sdk/protocol-http is expected by the signer
  const signedRequest = await signer.sign(request);
  // Log details of the signed request for debugging
  // logDebug('Attempting to fetch signed request with native fetch:');
  // logDebug('  Method:', signedRequest.method);
  // logDebug('  URL:', `https://${signedRequest.hostname}${signedRequest.path}`);
  // logDebug('  Headers:', signedRequest.headers);
  // Construct a standard Request object for the native fetch API
  const url = `https://${signedRequest.hostname}${signedRequest.path}`;

  const fetchRequest = new Request(url, {
    method: signedRequest.method,
    headers: signedRequest.headers, // signedRequest.headers is a plain object
    body: signedRequest.body, // body will be undefined for GET, which is correct
  });
  try {
    const response = await fetch(fetchRequest);

    if (!response.ok) {
      // response.ok is true for statuses 200-299
      let errorBodyText = 'Failed to read error body';
      try {
        // Clone the response to allow reading the body multiple times if needed
        const errorResponseClone = response.clone();
        errorBodyText = await errorResponseClone.text();
      } catch (bodyError) {
        logWarn('Could not read error response body:', bodyError);
      }
      // Include more details from the response object
      logError('Native fetch error response:', {
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries(response.headers.entries()),
        body: errorBodyText,
      });
      throw new Error(
        `HTTP error! status: ${response.status}, statusText: ${response.statusText}, body: ${errorBodyText}`,
      );
    }
    return response; // Return the native Response object
  } catch (fetchError) {
    logError('Native fetch failed:', fetchError);
    // Re-throw the original error to be caught by the caller
    throw fetchError;
  }
};

const getPollData = async (breakUuidParam, credentialsProvider) => {
  if (!pollUrl) {
    throw new Error('Poll URL is not configured. Call initialize() first.');
  }
  logInfo('getPollData() Backend GET Poll API (Signed)');

  const request = new HttpRequest({
    hostname: new URL(pollUrl).hostname,
    path: `/v1/poll/${breakUuidParam}`,
    method: 'GET',
    headers: {
      'host': new URL(pollUrl).hostname, // 'host' header is required for signing
      'Content-Type': 'application/json',
      'Accept-Language': 'en-US',
    },
  });

  try {
    const response = await signedFetch(request, credentialsProvider);
    logInfo('getPollData() Content Response, OKAY!');

    // Add better error handling for JSON parsing
    let caughtData;
    try {
      const responseText = await response.text();
      // logInfo('LI – Raw response text:', responseText);
      // logDebug('Raw response text:', responseText);
      caughtData = JSON.parse(responseText);
    } catch (jsonError) {
      logError('JSON parsing error:', jsonError);
      throw new Error(`Invalid JSON response from API: ${jsonError.message}`);
    }

    return caughtData.results;
  } catch (error) {
    logError('Error in signed getPollData:', error);
    throw error;
  }
};

const putPollData = async (breakUuidParam, optionNumberParam, credentialsProvider) => {
  if (!pollUrl) {
    throw new Error('Poll URL is not configured. Call initialize() first.');
  }
  logInfo('putPollData() Backend PUT Poll API (Signed)');

  const body = JSON.stringify(optionNumberParam);

  const request = new HttpRequest({
    hostname: new URL(pollUrl).hostname,
    path: `/v1/poll/${breakUuidParam}/option/${optionNumberParam}`,
    method: 'PUT',
    headers: {
      'host': new URL(pollUrl).hostname, // 'host' header is required for signing
      'Content-Type': 'application/json',
      'Accept-Language': 'en-US',
    },
    body: body,
  });

  try {
    const response = await signedFetch(request, credentialsProvider);
    logInfo('putPollData() Content Response, OKAY!');

    const caughtData = await response.json();

    return caughtData.results;
  } catch (error) {
    logError('Error in signed putPollData:', error);
    throw error;
  }
};

// const localizedUrl = import.meta.env.VITE_APP_LOCALIZED_URL;

// https://localized-dev.bsg-svc.com/api/v1/recommendations?latitude=36.98&longitude=-122.01&category=restaurants&radius=5000&limit=20&cuisineCategory=mexican

// https://localized-dev.bsg-svc.com/api/v1/recommendations?latitude=36.98&longitude=-122.01&category=restaurants&radius=5000&limit=20&cuisineCategory=mexican
const getLocalizedRecommendationsData = async (
  viewerLatitudeParam,
  viewerLongitudeParam,
  genAiTypeParam,
  genAiTermParam,
) => {
  if (!localizedUrl) {
    throw new Error('Localized Recommendations API is not declared.');
  }
  // console.log(` `);
  // console.log(` `);
  // console.log(`000000`);
  // console.log(`    genAiTypeParam: ${genAiTypeParam}`);
  // console.log(`      genAiTermParam: ${genAiTermParam}`);
  // console.log(`000000`);
  // console.log(` `);
  // console.log(` `);

  let termCategoryQuery = '';

  if (genAiTermParam) {
    if (genAiTypeParam === 'restaurants') {
      termCategoryQuery = `&cuisineCategory=${genAiTermParam}`;
    } else if (genAiTypeParam === 'leisure' || genAiTypeParam === 'sports') {
      termCategoryQuery = `&activityCategory=${genAiTermParam}`;
    }
  }

  // console.log(` `);
  // console.log(` `);
  // console.log(`111111`);
  // console.log(`    termCategoryQuery: ${termCategoryQuery}`);
  // console.log(`111111`);
  // console.log(` `);
  // console.log(` `);

  logInfo('getLocalizedRecommendationsData() Backend GET Localized Recommendations API');

  const localizedApi = new URL(localizedUrl);
  const request = `${localizedApi}/v1/recommendations?latitude=${viewerLatitudeParam}&longitude=${viewerLongitudeParam}&category=${genAiTypeParam}&radius=50000&limit=20${termCategoryQuery}`;

  // console.log(` `);
  // console.log(` `);
  // console.log(`222222`);
  // console.log(`    request: ${request}`);
  // console.log(`222222`);
  // console.log(` `);
  // console.log(` `);

  try {
    const response = await fetch(request);

    console.log('getLocalizedRecommendationsData() Content Response, OKAY!');

    if (!response.ok) {
      const httpError = new Error(`getJsonData() HTTP error! status: ${response.status}`);
      httpError.status = response.status;
      throw httpError;
    }

    const results = await response.json();

    // console.log(` )(*&*^%$`);
    // console.log(`    results: ${JSON.stringify(results.data)}`);
    // console.log(` )(*&*^%$`);

    return results.data;
  } catch (error) {
    logError('Error in signed getLocalizedRecommendationsData:', error);
    throw error;
  }
};

const backendApis = {
  getPollData,
  putPollData,
  getLocalizedRecommendationsData,
};

export default backendApis;
